import Vue from 'vue'
import 'floating-vue/dist/style.css'
import {
    // Directives
    VTooltip,
    VClosePopper,
} from 'floating-vue';

Vue.directive('tooltip', VTooltip)
Vue.directive('close-popper', VClosePopper)